import { IProjectsModel } from '../stores/projects';

export const getConnectiorString = (project: IProjectsModel) => `<!-- Global site tag - InsightArc Clickstream connector -->
<script async src="https://www.insightarc.com/js/iarc.js"></script>
<script>
 window.iArcConfig = {
  "apiKey": "${project?.apiToken}"
 }
</script>`;
